import { useQuery } from '@tanstack/react-query'
import omitBy from 'lodash/omitBy'
import { createListFetcher } from 'src/api'

export default function useQueryTable({
  name,
  searchText,
  additionalFilters,
  pageSize,
  pageIndex,
  _id,
  enabled = true,
}) {
  const fetchDataOptions = omitBy(

    {
      pageIndex: !searchText && pageIndex,
      pageSize: pageSize,
      searchText,
      _id: _id ? _id : null,
      additionalFilters: additionalFilters ? additionalFilters : null,
    },
    val => val?.toString()?.trim() === '' || val === null || val === undefined
  )
  const { data, isLoading, isFetching, refetch } = useQuery(
    [name, fetchDataOptions],
    createListFetcher(name),
    {
      enabled,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  )

  return { data, isLoading, isFetching, refetch }
}
